// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./src/css/tgs.css
 ** module id = 10
 ** module chunks = 1
 **/